(function() {

    /**
     * Exécute une requête AJAX
     * @param method méthode de la requête (GET, POST, …)
     * @param url URL à appeler
     * @param postData Données à envoyer
     * @param success Callback quand l'appel a abouti et renvoyé des données
     * @param error Callback quand l'appel a échoué
     */
    function xhr(method, url, postData, success, error) {
        var req = new XMLHttpRequest();
        req.addEventListener('loadend', function() {
            if (req.status !== 200) {
                error(req);
            } else {
                success(req);
            }
        });
        req.open(method, url);
        req.send(postData);
    }

    // Déclenche les appels ci-dessous une fois que la page a fini son chargement intégral.
    window.addEventListener('load', function() {

        // Récupération d'un objet jQuery
        var $ = jQuery.noConflict();

        // Chargement dynamique des actualités
        var actualiteEtFocusCards = document.querySelectorAll('.js-actualite-et-focus');
        [].forEach.call(actualiteEtFocusCards, function(card) {
            var zone = card.querySelector('.js-actualite-et-focus__actualites');
            var filtres = card.querySelectorAll('[data-filtre]');
            var maxDisplayed = 6;

            function cleanZone() {
                // Remove all news that are not focus ones.
                [].forEach.call(zone.querySelectorAll('.img-header__card'), function(item) {
                    item.parentElement.removeChild(item);
                });
            }

            function appendItem(data) {
                // Build news item
                var article = document.createElement('article');
                article.classList.add('img-header__card');
                article.classList.add('img-header__card-image', 'img-header__card--overlap', 'img-header__card--featured');
                article.style = 'background-image: url(\'' + data.image + '\')';
                var a = document.createElement('a');
                a.classList.add('img-header__card-link','img-header__card-link--overlap');
                a.href = data.url;
                article.append(a);
                var header = document.createElement('header');
                header.classList.add('img-header__card-header');
                var cartouche = document.createElement('date');
                cartouche.classList.add('img-header__card-tag', 'tag', 'tag--secondary', 'tag--big', 'tag--noborder');
                cartouche.innerText = data.dates;
                header.append(cartouche);
                var title = document.createElement('h5');
                title.classList.add('img-header__card-title', 'img-header__card--clamped');
                title.innerText = data.titre;
                header.append(title);
                a.append(header);
                article.append(a);
                zone.appendChild(article);
            }

            function loadContents(filtres) {
                // Change active button state
                var active = card.querySelector('.actualite-et-focus__filtre-link--active');
                if (active) {
                    active.classList.remove('actualite-et-focus__filtre-link--active');
                }
                var button = card.querySelector('[data-filtre="' + filtres + '"]');
                if (button) {
                    button.classList.add('actualite-et-focus__filtre-link--active');
                }

                // Limit the number of displayed news
                var remaining = maxDisplayed;

                // Query to server to get some news
                var params = [];
                [].forEach.call(filtres.split(","), function(filtre) {
                    params.push('thematique=' + filtre);
                });
                params.push('beanKey=41642b25-7124-429f-a6c3-188566547291');
                xhr('GET', '/uca/api/fichesActualitesEtFocus?' + params.join('&'), null, function success(response) {
                    var items = JSON.parse(response.responseText);
                    cleanZone();
                    items.forEach(function(item) {
                        if (remaining > 0) {
                            appendItem(item);
                            remaining--;
                        }
                    });

                }, function error(response) {

                });
            }

            // init
            [].forEach.call(filtres, function(filtre) {
                var isDefault = filtre.getAttribute('data-filtre-default') != null;
                filtre.addEventListener('click', function() {
                    loadContents(filtre.getAttribute('data-filtre'), isDefault);
                });
                if (isDefault) {
                    loadContents(filtre.getAttribute('data-filtre'), true);
                }
            });
        });

    });

})();
